export const dateWithoutTimezone = (date: Date): string => {
  const offset = date.getTimezoneOffset() * 60000; //offset in milliseconds
  const withoutTimeZone = new Date(date.valueOf() - offset)
    .toISOString()
    .slice(0, -1);
  return withoutTimeZone;
};
